import React from 'react';
import PropTypes from 'prop-types';
import RadioItem from './RadioItem';
import './_styles_/RadioField.css';
import { joinClassNames } from '../../utils';

RadioField.propTypes = {
    values: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
    })).isRequired,
    selectedValue: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    inputIdBase: PropTypes.string.isRequired,
    className: PropTypes.string,
};

RadioField.defaultProps = {
    selectedValue: null,
    className: '',
};

function RadioField(props) {
    const {
        values,
        selectedValue,
        onChange,
        inputIdBase,
        className,
    } = props;
    return (
        <div className={joinClassNames('radio-field', className)}>
            {values.map((value) => (
                <RadioItem
                    key={value.id}
                    id={value.id}
                    label={value.label}
                    onSelect={onChange}
                    isSelected={selectedValue === value.id}
                    inputId={`${inputIdBase}-${value.id}`}
                />
            ))}
        </div>
    );
}

export default RadioField;
